import { COMMISSIONS_POLICIES_ADD_INCENTIVE, COMMISSIONS_POLICIES_DISCONFIRM_INCENTIVE } from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_POLICIES_ADD_INCENTIVE:
      return {
        ...state,
        policies: {
          ...state.policies,
          // Set Incentive Values
          incetiveValues: action.data.incentiveValuesUpdated,
          // Set flag confirmed
          listIncentives: action.data.listIncentivesUpdated,
        }
      }
    case COMMISSIONS_POLICIES_DISCONFIRM_INCENTIVE: 
      return {
        ...state,
        policies: {
          ...state.policies,
          listIncentives: action.data.listIncentivesUpdated
        }
      }

    default:
      return state
  }
}
